import { useState } from 'react'
import { getKyousouApiClient, handleError, ApiErrorResponse } from '../../../../services/network'
import { useSnackBar } from '../../../../providers/snack_bar_provider'
import { SlideBusinessAbstract, BusinessAbstractFormData } from './types'

export const useBusinessAbstractUpdate = () => {
  const apiClient = getKyousouApiClient()
  const { showSnackBar } = useSnackBar()
  const [isUpdating, setIsUpdating] = useState(false)

  const updateBusinessAbstract = async (
    id: string,
    data: BusinessAbstractFormData,
    setBusinessAbstract: (businessAbstract: SlideBusinessAbstract) => void,
    resetForm: (data: BusinessAbstractFormData) => void
  ) => {
    if (!id) return

    setIsUpdating(true)

    try {
      const response = await apiClient.business.slideAbstractUpdateUpdate({
        businessIdeaId: id,
        ...data,
      })

      if (response.data?.businessAbstract) {
        setBusinessAbstract(response.data.businessAbstract)
        showSnackBar(['事業概要を更新しました'], 'success')

        resetForm({
          projectName: response.data.businessAbstract.projectName,
          marketBackground: response.data.businessAbstract.sections.marketBackground,
          competitorAnalysis: response.data.businessAbstract.sections.competitorAnalysis,
          businessChance: response.data.businessAbstract.sections.businessChance,
          businessContentFirst: response.data.businessAbstract.sections.businessContentFirst,
          businessContentSecond: response.data.businessAbstract.sections.businessContentSecond,
        })
      }
    } catch (e) {
      console.error('事業概要の更新に失敗しました:', e)
      handleError(e as ApiErrorResponse, showSnackBar)
    } finally {
      setIsUpdating(false)
    }
  }

  return {
    isUpdating,
    updateBusinessAbstract,
  }
}
